<div class="legend">
	<div class="title">{{ title() }}</div>
	<div class="keys">
		@for (item of items(); track item.label) {
		<div class="key">
			<div class="swatch-and-label">
				<div class="swatch" [ngStyle]="item.style"></div>
				<div class="label">
					{{ item.label }}
				</div>
			</div>
			<div class="count">{{ item.count }} {{ itemLabel() }}</div>
		</div>
		}
	</div>
</div>
